/*------------------------------------*\
	#SCRIPTS
\*------------------------------------*/

document.addEventListener("DOMContentLoaded", () => {
	const lazyStylesheet = document.querySelector('link[rel="stylesheet"][media="print"]');

	if (lazyStylesheet) {
		lazyStylesheet.media = "all";
	}
});


import 'wicg-inert';

import "./01-general/address-autocomplete";
import "./01-general/address-autocomplete-validation";
import "./01-general/animation"
import "./01-general/back-to-top";
import "./01-general/calculator-flag";
import "./01-general/cookiebanner";
import "./01-general/formControlSelection";
import "./01-general/formControlValidation";
import "./01-general/header";
import "./01-general/inputTelephoneValidation";
import "./01-general/interactionImage";
import "./01-general/modal";
import "./01-general/range-slider";
import "./01-general/swiperInit";
import "./01-general/tabbed";
import "./01-general/tabLayout";
import "./01-general/table";
import "./01-general/tabs";
import "./01-general/tooltip";
import "./01-general/aklamio";

// Solar Lead Strecke
import "./01-general/solarLeadForm-address-alternate";
import "./01-general/solarLeadForm-fileUpload";
import "./01-general/solarLeadForm-navigation";
import "./01-general/solarLeadForm-roof-disabler";
import "./01-general/solarLeadForm-stepper";
import "./01-general/solarLeadForm-tracking";
import "./01-general/solarLeadForm-validation";

// Everyone Energy
import "./01-general/everyone-energy";

// Tracking
import "./01-general/tracking-aklamio";
import "./01-general/tracking-utm";
